
import { Component, Input, OnDestroy } from '@angular/core';
import { DeviceDetectionService } from 'src/app/services/detectipad.service';

@Component({
    selector: 'loading',
    template: `
		<div id="pause" [class.auto-size]="autoSize" [style.height]="type=='kpi'? '100%' : 'calc(100% - 55px)'" class="align-items-center justify-content-center">
			<div class="loader" [style.height.px]="autoSize ? null : (type=='kpi'?40:130)" [style.width.px]="autoSize ? null : (type=='kpi'?40:130)"></div>
			<!-- <div id="spinner"></div> -->
			<!-- <div id="spinnertext" >Loading...</div> -->
		</div>
	`,
    styleUrls: ['loading.scss'],
    standalone: false
})

export class LoadingComponent {
	@Input() type!: any
	// when true the loader scales with the widget's size instead of the fixed 40px / 130px
	@Input() autoSize: boolean = false

	constructor(public deviceDetectionService: DeviceDetectionService) {}
}
